import React from 'react';
import { connect, WithStore, MapStateToProps, MapDispatchToProps } from '../../redux/services/Imports';
import './CardBlog.scss';
import './CardBlog-media.scss';
import { Props } from './interfaces';
import { GetTypeNews } from '../../services/GlobalFunctions';

import { EnumUrlsPages } from '../../services/Enum';
import {Link} from "../Link/Link";

const CardBlog = ({ alias, uri, image, title, date, type, link, linkOut, stretchy, widthWindow }: Props) => {
  const contentCard = (
    <>
      {image ? (
        <img
          src={`${image}`}
          className="card-blog__image"
          alt="card-blog"
          style={widthWindow > 720 ? {} : { opacity: '0.4' }}
        />
      ) : (
        <div className="card-blog__image"></div>
      )}
      <div className="card-blog__content">
        <p className="card-blog__type">{GetTypeNews(type)}</p>
        <div>
          <h3 className="card-blog__title">{title}</h3>
          <p className="card-blog__date">{date}</p>
        </div>
      </div>
    </>
  );

  const className = `card-blog${stretchy ? ' card-blog_stretchy' : ''}`;
  const styles = widthWindow > 720 ? { backgroundColor: 'transparent' } : { backgroundColor: '#000' };

  return linkOut ? (
    <a href={link} className={className} style={image ? styles : {}}>
      {contentCard}
    </a>
  ) : (
    <Link
      to={uri ? uri : `${EnumUrlsPages.live}${alias}/`}
      className={className}
      style={image ? styles : {}}
    >
      {contentCard}
    </Link>
  );
};

export default WithStore()(connect(MapStateToProps, MapDispatchToProps)(CardBlog));
